module.exports = __webpack_public_path__ + "static/media/sorry-img.054c4b4d.jpg";